import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useWallet } from "../hooks/useWallet";
import { setOutboxContext, loadOutbox, flush } from "../lib/outbox";
import { probe } from "../lib/net";

export const OutboxBridge = () => {
  const { user } = useAuth();
  const { refresh } = useWallet() || {};
  useEffect(() => {
    setOutboxContext({ user, onSynced: (d) => { toast.success(`Synced: ${d.title || "job"}`); refresh?.(); window.dispatchEvent(new Event("dropit-synced")); }, onFlushed: () => refresh?.() });
    if (user) { loadOutbox().then((items) => items.length && probe().then((ok) => ok && flush())); }
  }, [user, refresh]);
  return null;
};
